import PatientListingPage from '@/pages/PatientListingPage/PatientListingPage.vue'

export default PatientListingPage
